<template>
	<div class="leftres">
		<div>
			<div :class=" showorhide ? 'inputtop' : 'inputtops' ">
				<div v-for="(item , index) of formdata" :key="index" style="display: inline-block;">
					<Commondropdownlist ref="reportIMSSRef" :options="item.options" :lablewith="item.lablewith"
						:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:minleft="item.minleft" :minrigth="item.minrigth"
						:showControls="item.showControls !== undefined ? item.showControls : true"
						:width="item.width"></Commondropdownlist>
				</div>
				<div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
					<CommonBtngroup ref="btngroup" :qhide="false" :chackbox="true" checktitle="发票待处理" :show="showorhide"
						@showclick="showclick" @hide="hide" @select="select" @reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;">
				</div>
			</div>
			<div class="TableBox"
				style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<ReportIMSSales :tableData="tableData" :total="total" :pageNo="pageindex" :pageSize="pageSize" @Export="Export"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></ReportIMSSales>
			</div>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from '../../../components/common-dropdownlist.vue'
	import CommonBtngroup from '../../../components/commongroup.vue'
	import Dialog from '../../../components/dialog.vue'
	import ReportIMSSales from './components/reportIMSSalestable.vue'
	import utils from '../../../common/utils'
	import {
		SMSReportIMSSalesList,
		SMSReportIMSSalesExport,
		InventoryClassList,
		Status,
		HelperInvoiceChecked,
		GetProvince,
		GetHelperHosGrade
	} from '@/api/home'
	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			Dialog,
			ReportIMSSales
		},
		data() {
			return {
				total: 1,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				dialogVisibles: false,
				showorhide: true,
				formdata: [{
						inputdata: '',
						title: '发票状态',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'selectMultiple',
						width: '210px',
						marginLeft: '24px',
						options: [

						]
					},
					{
						inputdata: '',
						title: '发票号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '100px'
					},
					{
						inputdata: "",
						title: "开票日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "",
						types: "",
						inputtype: "date",
						width: "140px",
					},
					{
						inputdata: '',
						title: '出库单号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '购买方',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '80px'
					},
					{
						inputdata: '',
						title: '终端医院',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '100px'
					},
					{
						inputdata: "",
						title: "上传日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "",
						types: "",
						inputtype: "date",
						width: "140px",
					},

					{
						inputdata: '',
						title: '产品型号/名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '批号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '80px'
					},
					{
						inputdata: '',
						title: '产品线',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'selectMultiple',
						width: '210px',
						lablewith: '100px',
						options: [

						]
					},
					{
						inputdata: '',
						title: '省份',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'selectMultiple',
						width: '210px',
						options: [

						],
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '上报方',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '300px',
						lablewith: '85px'
					},
					{
						inputdata: '',
						title: '发票方向',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '230px',
						options: [{
							key: 0,
							value: '蓝票'
						}, {
							key: 1,
							value: '红票'
						}]
					},
					{
						inputdata: '',
						title: '销售',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '70px'
					}, {
						inputdata: '',
						title: '医院等级',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '210px',
						options: [],
						lablewith: '110px'
					},
					{
						inputdata: "",
						title: "审核时间",
						fontSize: "14px",
						color: "#333333",
						placeholder: "",
						types: "",
						inputtype: "date",
						width: "140px",
					},
					{
						inputdata: "",
						title: "含税单价",
						fontSize: "14px",
						color: "#333333",
						placeholder: "",
						types: "number",
						inputtype: "numbers",
						showControls: false,
						minleft: undefined,
						minrigth: undefined,
						width: "100px",
					},
					{
						inputdata: '',
						title: '销售方',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '80px'
					}
				],
				from: {
					Status: "",
					InvoiceNo: "",
					VouCode: "",
					SBDate1: "",
					SBDate2: "",
					CreateTime1: "",
					CreateTime2: "",
					CusName: "",
					TerminalHospital: "",
					Inventory: "",
					InvClass: "",
					ProvinceID: "",
					CreateOrgName: "",
					InvoiceChecked: "",
					ReturnFlag: "",
					SalesMan: "",
					HosGrade: '',
					Batch: "",
					UnDealWith: "",
					TaxUnitPrice1: "",
					TaxUnitPrice2: "",
					SellerName: "",
				},
			}
		},
		mounted() {
			this.$message.warning("请填写搜索条件！");
			this.$refs.reportIMSSRef[2].startTime = this.$utils.getFYearDate();
			//this.sMSReportIMSSalesList();
			this.HelperInvoiceChecked();
			this.inventoryClassList();
			this.getProvince();
			this.getHelperHosGrade();
		},
		methods: {
			//医院等级
			async getHelperHosGrade() {
				let {
					data,
					code,
					message
				} = await GetHelperHosGrade({})
				if (code == 0) {
					this.formdata[14].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.formdata[14].options.push(obj)
					})
				} else {
					this.$message({
						type: 'error',
						message: message
					})
				}
			},
			// 获取产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({

				})
				if (code == 0) {
					try {
						this.formdata[9].options = []
						data.data.map((item, index) => {
							let obj = {
								key: item.InvClass,
								value: item.InvClassName
							}
							this.formdata[9].options.push(obj)
						})
					} catch (error) {}
				}
			},
			// 列表
			async sMSReportIMSSalesList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				let {
					data,
					code
				} = await SMSReportIMSSalesList({
					// Status: this.from.Status,
					InvoiceChecked: this.from.InvoiceChecked,
					InvoiceNo: this.from.InvoiceNo,
					VouCode: this.from.VouCode,
					SBDate1: this.from.SBDate1,
					SBDate2: this.from.SBDate2,
					CreateTime1: this.from.CreateTime1,
					CreateTime2: this.from.CreateTime2,
					CusName: this.from.CusName,
					TerminalHospital: this.from.TerminalHospital,
					Inventory: this.from.Inventory,
					InvClass: this.from.InvClass,
					ProvinceIDs: this.from.ProvinceID,
					CreateOrgName: this.from.CreateOrgName,
					ReturnFlag: this.from.ReturnFlag,
					SalesMan: this.from.SalesMan,
					HosGrade: this.from.HosGrade,
					VerifyTime1: this.from.VerifyTime1,
					VerifyTime2: this.from.VerifyTime2,
					TaxUnitPrice1: this.from.TaxUnitPrice1,
					TaxUnitPrice2: this.from.TaxUnitPrice2,
					Batch: this.from.Batch,
					UnDealWith: this.$refs.btngroup ? (this.$refs.btngroup.checkeds ? 1 : '') : '',
					pageSize: this.pageSize,
					pageIndex: this.pageindex,
					SellerName: this.from.SellerName,
				})
				//console.log(code, data.data)
				if (code == 0) {
					this.total = data.Count
					if (data.data) {
						this.tableData = data.data
					}
					loading.close();
				}
				loading.close();
			},
			// 导出
			async sMSReportIMSSalesExport() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await SMSReportIMSSalesExport({
					// Status: this.from.Status,
					InvoiceChecked: this.from.InvoiceChecked,
					InvoiceNo: this.from.InvoiceNo,
					VouCode: this.from.VouCode,
					SBDate1: this.from.SBDate1,
					SBDate2: this.from.SBDate2,
					CreateTime1: this.from.CreateTime1,
					CreateTime2: this.from.CreateTime2,
					CusName: this.from.CusName,
					TerminalHospital: this.from.TerminalHospital,
					Inventory: this.from.Inventory,
					InvClass: this.from.InvClass,
					ProvinceIDs: this.from.ProvinceID,
					CreateOrgName: this.from.CreateOrgName,
					ReturnFlag: this.from.ReturnFlag,
					SalesMan: this.from.SalesMan,
					HosGrade: this.from.HosGrade,
					VerifyTime1: this.from.VerifyTime1,
					VerifyTime2: this.from.VerifyTime2,
					TaxUnitPrice1: this.from.TaxUnitPrice1,
					TaxUnitPrice2: this.from.TaxUnitPrice2,
					Batch: this.from.Batch,
					UnDealWith: this.$refs.btngroup ? (this.$refs.btngroup.checkeds ? 1 : '') : '',
					pageSize: this.pageSize,
					pageIndex: this.pageindex,
					SellerName: this.from.SellerName
				})
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `IMS销售报表${str}`, "xlsx")
					loading.close();
				} else {
					// 返回json
					this.$message.warning('导出失败');
					loading.close();
				}
				loading.close()
			},
			// 导出
			Export() {
				this.sMSReportIMSSalesExport()
			},
			// 状态下拉
			async HelperInvoiceChecked() {
				let {
					code,
					data
				} = await HelperInvoiceChecked({})
				if (code == 0) {
					this.formdata[0].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.formdata[0].options.push(obj)
					})

				}
			},
			//省份列表
			async getProvince() {
				let {
					data,
					code,
					message
				} = await GetProvince({})
				console.log(data, '省');
				if (code == 0) {
					this.formdata[10].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.formdata[10].options.push(obj)
					})

				} else {
					this.$message({
						type: 'error',
						message: "省份列表加载失败"
					})
				}
			},

			// 清空
			reset() {
				this.$refs.btngroup.checkeds = false
				this.$refs.reportIMSSRef.map((item, index) => {
					if (index == 2 || index == 6 || index == 15) {
						item.startTime = ''
						item.endTime = ''
					} else if (index == 16) {
						item.modelvalueleft = ''
						item.modelvalueright = ''
					} else {
						item.modelvalue = ''
					}
				})
			},
			hide() {
				this.showorhide = false
			},
			showclick() {
				this.showorhide = true
			},
			select() {
				this.pageindex = 1
				try {
					this.from.InvoiceChecked = this.$refs.reportIMSSRef[0].modelvalue ? this.$refs.reportIMSSRef[0]
						.modelvalue.join(',') : '';
					this.from.InvoiceNo = this.$refs.reportIMSSRef[1].modelvalue
					this.from.SBDate1 = this.$refs.reportIMSSRef[2].startTime
					this.from.SBDate2 = this.$refs.reportIMSSRef[2].endTime
					this.from.VouCode = this.$refs.reportIMSSRef[3].modelvalue
					this.from.CusName = this.$refs.reportIMSSRef[4].modelvalue
					this.from.TerminalHospital = this.$refs.reportIMSSRef[5].modelvalue
					this.from.CreateTime1 = this.$refs.reportIMSSRef[6].startTime
					this.from.CreateTime2 = this.$refs.reportIMSSRef[6].endTime
					this.from.Inventory = this.$refs.reportIMSSRef[7].modelvalue
					this.from.Batch = this.$refs.reportIMSSRef[8].modelvalue
					this.from.InvClass = this.$refs.reportIMSSRef[9].modelvalue ? this.$refs.reportIMSSRef[9].modelvalue
						.join(',') : ''
					this.from.ProvinceID = this.$refs.reportIMSSRef[10].modelvalue ? this.$refs.reportIMSSRef[10]
						.modelvalue
						.join(',') : '';
					this.from.CreateOrgName = this.$refs.reportIMSSRef[11].modelvalue
					this.from.ReturnFlag = this.$refs.reportIMSSRef[12].modelvalue
					this.from.SalesMan = this.$refs.reportIMSSRef[13].modelvalue
					this.from.HosGrade = this.$refs.reportIMSSRef[14].modelvalue
					this.from.VerifyTime1 = this.$refs.reportIMSSRef[15].startTime
					this.from.VerifyTime2 = this.$refs.reportIMSSRef[15].endTime
					this.from.TaxUnitPrice1 = this.$refs.reportIMSSRef[16].modelvalueleft
					this.from.TaxUnitPrice2 = this.$refs.reportIMSSRef[16].modelvalueright
					this.from.UnDealWith = this.$refs.btngroup.checkeds ? 1 : ''
					this.from.SellerName = this.$refs.reportIMSSRef[17].modelvalue
					this.sMSReportIMSSalesList()
				} catch (error) {
					this.sMSReportIMSSalesList()
				}
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex
				this.sMSReportIMSSalesList()
			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.sMSReportIMSSalesList()
			},
		}
	}
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 220px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		transition: all 0.3s;
		overflow: hidden;
	}

	.inputtops {
		width: 980px;
		height: 40px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		padding-bottom: 64px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 10px;
		width: 318px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 95px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 0px;
	}
</style>